import './app.css';
import { MetaProvider, Title } from '@solidjs/meta';
import { Router } from '@solidjs/router';
import { FileRoutes } from '@solidjs/start/router';
import { Suspense } from 'solid-js';
import { ErrorBoundary } from './components/error-boundary.tsx';
import { Intl } from './providers/intl.tsx';
import { UserContext } from './providers/user.tsx';

export default function App() {
	return (
		<Router
			explicitLinks
			preload
			root={(props) => (
				<MetaProvider>
					<UserContext>
						<Suspense>
							<Intl>
								<Title>Admin • Bend Bike Rides</Title>
								<ErrorBoundary>{props.children}</ErrorBoundary>
							</Intl>
						</Suspense>
					</UserContext>
				</MetaProvider>
			)}
		>
			<FileRoutes />
		</Router>
	);
}
